// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___d2ce0b9a8041a9bba43","cls2":"Comments-cls2__c8552eb5c41ad4491496 Comments-cls1___d2ce0b9a8041a9bba43"};